import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardContent} from '@angular/material/card';
import {MatIcon} from '@angular/material/icon';
import {MatListItemIcon, MatListOption, MatSelectionList, MatSelectionListChange,} from '@angular/material/list';
import {MatDrawer, MatDrawerContainer, MatDrawerContent} from '@angular/material/sidenav';
import {MatToolbar} from '@angular/material/toolbar';
import {ActivatedRoute, Params, Router, RouterLink} from '@angular/router';
import {AccessTokenCardComponent} from '@app/admin/access-token-card/access-token-card.component';
import {Client, ClientService} from '@app/admin/client.service';
import {AuthService} from '@app/auth/auth.service';
import {SiteConfig, SiteConfigService} from '@app/shared/site-config.service';
import {User, UserService} from '@app/shared/user.service';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {BadgeCardComponent} from '../badge-card/badge-card.component';
import {BillingAdminComponent} from '../billing-admin/billing-admin.component';
import {ContentAdminComponent} from '../content-admin/content-admin.component';
import {ContentCardComponent} from '../content-card/content-card.component';
import {DeleteCardComponent} from '../delete-card/delete-card.component';
import {SiteCardComponent} from '../site-card/site-card.component';
import {StreamAdminComponent} from '../stream-admin/stream-admin.component';
import {TagAdminComponent} from '../tag-admin/tag-admin.component';
import {TagsCardComponent} from '../tags-card/tags-card.component';
import {UpgradeCardComponent} from '../upgrade-card/upgrade-card.component';
import {UsersCardComponent} from '../users-card/users-card.component';

@Component({
    selector: 'frog-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    imports: [
        MatToolbar,
        MatButton,
        RouterLink,
        MatIcon,
        MatDrawerContainer,
        MatDrawer,
        MatSelectionList,
        MatListOption,
        MatListItemIcon,
        MatDrawerContent,
        UpgradeCardComponent,
        ContentAdminComponent,
        BillingAdminComponent,
        TagAdminComponent,
        StreamAdminComponent,
        SiteCardComponent,
        TagsCardComponent,
        BadgeCardComponent,
        ContentCardComponent,
        UsersCardComponent,
        DeleteCardComponent,
        MatCard,
        MatCardContent,
        AsyncPipe,
        AccessTokenCardComponent,
    ],
})
export class AdminComponent implements OnInit {
    public routeParams$: Observable<Params>;
    public user$: Observable<User>;
    public siteConfig$: Observable<SiteConfig>;
    public client$: Observable<Client>;
    public appVersion = environment.appVersion;
    public hosted = environment.hosted;

    constructor(
        private userService: UserService,
        private authService: AuthService,
        private siteConfigService: SiteConfigService,
        private clientService: ClientService,
        private route: ActivatedRoute,
        private router: Router,
    ) {
        this.routeParams$ = this.route.params;
        this.user$ = this.authService.user;
        this.siteConfig$ = this.siteConfigService.siteConfig;
        this.client$ = this.clientService.get();
    }

    ngOnInit(): void {}

    changeTabs(change: MatSelectionListChange) {
        this.router.navigate(['a/', change.options[0].value]);
    }
}
